var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-form",
    { on: { submit: _vm.onSubmit } },
    [
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-name",
            label: "Nom",
            "label-for": "input-name",
          },
        },
        [
          _c("b-form-input", {
            attrs: {
              id: "input-name",
              type: "text",
              placeholder: "Exemple : Grands classiques",
              required: "",
            },
            on: {
              update: function ($event) {
                return _vm.toRefresh()
              },
            },
            model: {
              value: _vm.form.quiz_name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_name", $$v)
              },
              expression: "form.quiz_name",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-category",
            label: "Catégorie",
            "label-for": "input-category",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.categoriesValues },
            on: {
              change: function ($event) {
                return _vm.toRefresh()
              },
            },
            model: {
              value: _vm.form.quiz_category,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_category", $$v)
              },
              expression: "form.quiz_category",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            id: "input-group-level",
            label: "Niveau de difficulté",
            "label-for": "input-level",
          },
        },
        [
          _c("b-form-select", {
            attrs: { options: _vm.levelValues },
            on: {
              change: function ($event) {
                return _vm.toRefresh()
              },
            },
            model: {
              value: _vm.form.quiz_level,
              callback: function ($$v) {
                _vm.$set(_vm.form, "quiz_level", $$v)
              },
              expression: "form.quiz_level",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.form.questions, function (question, index) {
        return _c(
          "div",
          { key: "q" + index, staticClass: "form_questions" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: `input-group-question${index}`,
                          "label-for": `input-question${index}`,
                          label: `Question ${index + 1}`,
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: `input-question${index}`,
                            type: "text",
                            maxlength: "125",
                            placeholder: "Exemple : Quel jour sommes-nous ?",
                            required: "",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.toRefresh()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].question,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.questions[index],
                                "question",
                                $$v
                              )
                            },
                            expression: "form.questions[index].question",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-right" }, [
                          _vm._v(
                            _vm._s(`${_vm.form.questions[index].question.length}
             / 125 caractères restants`) + "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: `input-group-answer${index}`,
                          "label-for": `input-answer${index}`,
                          label: "Réponse attendue",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: `input-answer${index}`,
                            placeholder: "Exemple : Lundi",
                            type: "text",
                            required: "",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.toRefresh()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].answer,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.questions[index], "answer", $$v)
                            },
                            expression: "form.questions[index].answer",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: `input-group-false1${index}`,
                          "label-for": `index-false1${index}`,
                          label: "Mauvaise réponse 1",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: `index-false1${index}`,
                            type: "text",
                            placeholder: "Exemple : Septembre",
                            required: "",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.toRefresh()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].false_1,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.questions[index],
                                "false_1",
                                $$v
                              )
                            },
                            expression: "form.questions[index].false_1",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: `input-group-false2${index}`,
                          "label-for": `index-false2${index}`,
                          label: "Mauvaise réponse 2",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: `index-false2${index}`,
                            type: "text",
                            placeholder: "Exemple : En 2021",
                            required: "",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.toRefresh()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].false_2,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.questions[index],
                                "false_2",
                                $$v
                              )
                            },
                            expression: "form.questions[index].false_2",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: `input-group-explanation${index}`,
                          "label-for": `input-explanation${index}`,
                          label: "Explication",
                        },
                      },
                      [
                        _c("b-form-textarea", {
                          attrs: {
                            id: `input-explanation${index}`,
                            type: "text",
                            maxlength: "550",
                            placeholder:
                              "Exemple : Le premier jour du reste de ta vie. C'est un matin comme tous les autres. Un nouveau pari. Rechercher un peu de magie dans cette inertie morose.",
                            required: "",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.toRefresh()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].explanation,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form.questions[index],
                                "explanation",
                                $$v
                              )
                            },
                            expression: "form.questions[index].explanation",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-right" }, [
                          _vm._v(
                            _vm._s(`${
                              _vm.form.questions[index].explanation.length +
                              (
                                _vm.form.questions[index].explanation.match(
                                  /\n\n/g
                                ) || []
                              ).length *
                                55
                            }
             / 550 caractères restants`) + "\n          "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Image" } },
                      [
                        _c("b-form-file", {
                          attrs: {
                            state: Boolean(_vm.form.questions[index].img),
                            placeholder:
                              "Choisissez un fichier ou déposez-le ici...",
                            "drop-placeholder": "Déposez-le ici...",
                          },
                          on: {
                            update: function ($event) {
                              return _vm.change()
                            },
                          },
                          model: {
                            value: _vm.form.questions[index].img,
                            callback: function ($$v) {
                              _vm.$set(_vm.form.questions[index], "img", $$v)
                            },
                            expression: "form.questions[index].img",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("b-col", [
                  _vm.form.questions[index].img
                    ? _c("div", { staticClass: "mt-3" }, [
                        _vm._v(
                          "\n          Fichier sélectionné: " +
                            _vm._s(
                              _vm.form.questions[index].img
                                ? _vm.form.questions[index].img.name
                                : ""
                            ) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("b-row"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    disabled: _vm.pending,
                    type: "submit",
                    variant: "primary",
                  },
                },
                [
                  _vm.pending
                    ? _c(
                        "span",
                        [
                          _c("b-spinner", {
                            attrs: { small: "", variant: "light" },
                          }),
                        ],
                        1
                      )
                    : _c("span", [_vm._v("\n          Enregistrer\n        ")]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }